import { useCallback, useEffect, useState } from "react";
import api from "../api";

const formatValue = (value, key) => {
  if (value === null || value === undefined || value === "") return "—";
  if (key.toLowerCase().includes("date")) return new Date(value).toLocaleDateString();
  if (typeof value === "number" && (key.toLowerCase().includes("amount") || key.toLowerCase().includes("rate"))) return `₹${value.toLocaleString("en-IN")}`;
  return String(value).replaceAll("_", " ");
};

function RecordList({ title, endpoint, columns }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");

  const loadRecords = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const response = await api.get(endpoint);
      setRecords(response.data.data || []);
    } catch (err) {
      setError(err.response?.data?.message || "Could not load records. Check that the API is running and you are signed in.");
    } finally { setLoading(false); }
  }, [endpoint]);

  useEffect(() => { loadRecords(); }, [loadRecords]);
  const filtered = records.filter((record) => Object.values(record).join(" ").toLowerCase().includes(query.toLowerCase()));

  return <section className="section-card record-page">
    <div className="record-heading"><div><h2>{title}</h2><p>Review and search the latest {title.toLowerCase()} records.</p></div><button className="secondary-button" onClick={loadRecords}>Refresh</button></div>
    <input className="table-search" aria-label={`Search ${title}`} value={query} onChange={(event) => setQuery(event.target.value)} placeholder={`Search ${title.toLowerCase()}…`} />
    {loading ? <p className="state-message">Loading records…</p> : error ? <p className="state-message error-message">{error}</p> : filtered.length === 0 ? <p className="state-message">No records found.</p> : <div className="table-wrap"><table><thead><tr>{columns.map(([key, label]) => <th key={key}>{label}</th>)}</tr></thead><tbody>{filtered.map((record) => <tr key={record._id}>{columns.map(([key]) => <td key={key}><span className={key.toLowerCase().includes("status") ? `status-badge ${record[key]}` : ""}>{formatValue(record[key], key)}</span></td>)}</tr>)}</tbody></table></div>}
  </section>;
}

export default RecordList;
